import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .table': {
      width: '100%',
      borderSpacing: 0,
      fontSize: '12px',
    },
    '& .tbody': {
      overflowX: 'hidden',
      height: '300px',
    },
    '& .tr': {
      border: 'none',
      '&: last-child': {
        '& .td': {
          border: 'none',
        },
      },
    },
    '& .tr:hover': {
      background: theme.palette.grey[50],
    },
    '& .th': {
      fontSize: '13px',
      fontWeight: 'bold',
      padding: theme.spacing(1),
      border: `none`,
      textAlign: 'left',
    },
    '& .td': {
      padding: '0px',
      fontSize: '12.5px',
      display: 'inline-block',
      alignItems: 'left',
      verticalAlign: 'middle',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      '&: last-child': {
        borderRight: 0,
      },
    },
  },
}));

export default useStyles;
